import React from "react";
import "./Poster.css";
import backLayer from "../media/back.png";
import middleLayer from "../media/middle.png";
import frontLayer from "../media/front.png";
import Speakers from "../Speakers/Speakers";
import CountDown from "../CountdownComponent/CountDownTimer";
import Footer from "../Footer/Footer";
import Giveaway from "../Giveaway/Giveaway";
import sponsors from "../media/sponsors.png";

export default function Poster() {
    return (
        <>
            <div className="parallax_layer parallax_layer-back">
                <div className="layer back">
                    <img src={backLayer} alt=""/>
                </div>
            </div>
            <div className="parallax_layer parallax_layer-middle">
                <div className="layer middle">
                    <img src={middleLayer} alt=""/>
                </div>
            </div>
            <div className="parallax_layer parallax_layer-front">
                <div className="layer front">
                    <img src={frontLayer} alt=""/>
                    <CountDown timeTillDate="11 29 2022, 5:30 pm" timeFormat="MM DD YYYY, h:mm a"/>
                    <Speakers />
                    <Giveaway />
                    <img src={sponsors} alt=""/>
                    <Footer />
                </div>
                
            </div>
        </>
    );
}
